import { useCustomerPerksVisitCreate } from "@boundless/bl-api-client/customer/services"
import Markdown from "react-markdown"

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Card, CardContent } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"

import type { Perk } from "@boundless/bl-api-client/customer/models"

import { Button } from "../ui/button"

export function PerkCard({ perk }: { perk: Perk }) {
  const { mutate: trackVisit } = useCustomerPerksVisitCreate({
    mutation: {
      onSuccess: ({ url }) => window.open(url, "_blank"),
    },
  })

  return (
    <Card className="h-fit w-sm">
      <CardContent>
        <Accordion type="single" collapsible>
          <AccordionItem value="item-1">
            <AccordionTrigger className="cursor-pointer py-0 hover:no-underline">
              <div className="flex flex-row gap-5">
                <Avatar className="h-12 w-12">
                  <AvatarImage
                    src={perk.logo || ""}
                    alt={`${perk.partner} logo`}
                  />
                  <AvatarFallback>{perk.partner.slice(0, 2)}</AvatarFallback>
                </Avatar>

                <div className="flex grow flex-col">
                  <h2 className="text-sm font-bold">{perk.partner}</h2>
                  <h3 className="text-xs">{perk.incentive}</h3>
                </div>
              </div>
            </AccordionTrigger>

            <AccordionContent className="flex h-fit flex-col gap-5 pt-5">
              <Separator />
              <div className="prose prose-sm w-full max-w-none">
                <Markdown>{perk.description}</Markdown>
              </div>
              <Button onClick={() => trackVisit({ slug: perk.slug })}>
                Visit Partner Site
              </Button>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </CardContent>
    </Card>
  )
}
